import { Controller } from "@hotwired/stimulus"

// A <details> used as a small menu: it closes when the page is clicked
// elsewhere, when Escape is pressed, and when Turbo leaves the page.
export default class extends Controller {
  connect() {
    this.away = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    document.addEventListener("click", this.away)
  }

  disconnect() {
    document.removeEventListener("click", this.away)
  }

  close() {
    this.element.removeAttribute("open")
  }
}
